import { ReactElement } from 'react';
import styles from './no-invites.module.scss';
import { UISpacer, UIText } from '@/ui';
import { useCompaniesTranslation } from '../hooks';

export function NoInvites(): ReactElement {
    const { t } = useCompaniesTranslation();

    return (
        <div className={styles.container}>
            <UIText variant={'large'}>
                {t('components.no_invites.title')}
            </UIText>
            <UISpacer multiplier={2} />
            <UIText type="default2">{t('components.no_invites.text')}.</UIText>
        </div>
    );
}
